import { ReactComponent as ChevronDown } from "@src/styles/icon/chevron-down.svg";
import { ReactComponent as ChevronUp } from "@src/styles/icon/chevron-up.svg";
import { Col, Collapse, Empty, Row } from "antd";
import React from "react";
import VideoCard from "./videoCard";
import moment from "moment"
import { InfoCircleOutlined } from "@ant-design/icons";
import "./view.scss";
const { Panel } = Collapse;

const ListVideoByCate = ({ list = { data: [] },updateDeleteList=() => {} ,callBackAddPlayList = () =>{}}) => {
  const renderListCard = (list) => {
    if (!Array.isArray(list) || list.length === 0) {
      return (
        <div className="center mt20 w100">
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        </div>
      );
    }
    return list.map((i) => (
      <Col span={8}>
        <VideoCard
          title={i.title}
          author={i.displayName || i.createId}
          time={i.updateDatetime ? moment(i.updateDatetime).format("YYYY/MM/DD HH:mm:ss") :""}
          description={i.videoExplanation}
          tag={i.tagLists || []}
          url={i.videoUrl || ""}
          videoId={i.id}
          updateDeleteList={updateDeleteList}
          machineList={i.machineNameLists}
          isEdit={i.isEdit}
          isDelete={i.isDelete}
          createTime={i.createDatetime}
          isVideoPlayList={i.isVideoPlayList}
          callBackAddPlayList ={callBackAddPlayList}
          avatarUrl={i.avatarUrl}
        />
      </Col>
    ));
  };
  return list.data.map((item) => (
    <Collapse
      key={item.categoryID}
      defaultActiveKey={"1"}
      style={{
        width: "100%",
      }}
      className="tabMachine mb20"
      expandIcon={({ isActive }) =>
        isActive ? <ChevronDown /> : <ChevronUp />
      }
      expandIconPosition="right"
    >
      <Panel
        key={"1"}
        header={
          <div className="bold">
            <InfoCircleOutlined
              style={{ color: "#0080cb", marginRight: 10, fontSize: 20 }}
            />
            {item.categoryName}
          </div>
        }
      >
        <Row
          style={{
            padding: 15,
          }}
          gutter={[16, 16]}
        >
          {renderListCard(item.videoDetailDTOs)}
        </Row>
      </Panel>
      {/* </div> */}
    </Collapse>
  ));
};

export default React.memo(ListVideoByCate);
